export const SYSTEM_IS_UNDER_MAINTENANCE = 'system_is_under_maintenance';
export const USER_INACTIVE = 'user_inactive';
export const VALIDATION_UNIQUE = 'unique';